import {
  useCampaignFilter,
  useCurrentWorkspace,
  useSetCampaignFilter,
} from '@gripp/shared-logic';
import {
  CampaignSearchInput,
  countFilters,
  FilterHeaders,
  tokens,
} from '@gripp/shared-ui';
import { Pressable, StyleSheet, View } from 'react-native';
import { AddButton } from '../../shared/components/addButton/addButton';

interface CampaignsFiltersProps {
  onAddPress?: () => void;
  showAddButton?: boolean;
  onFilterPress?: () => void;
}

export const CampaignsFilters = ({
  onAddPress,
  showAddButton = true,
  onFilterPress,
}: CampaignsFiltersProps) => {
  const workspace = useCurrentWorkspace();

  const { data: campaignFilter } = useCampaignFilter();
  const { mutateAsync: setCampaignFilter } = useSetCampaignFilter();
  // countFilters (shared helper) doesn't know about CampaignFilterModel.status,
  // so add it here. Each active status counts as one filter.
  const filterCount =
    countFilters(campaignFilter) + (campaignFilter?.status ? 1 : 0);

  return (
    <View style={styles.filtersContainer}>
      <FilterHeaders
        currentSearchKeyword={campaignFilter?.keyword}
        searchComponent={<CampaignSearchInput />}
        onFilterPress={onFilterPress ?? (() => undefined)}
        onSearchClose={() =>
          setCampaignFilter({ ...campaignFilter, keyword: '' })
        }
        filterCount={filterCount}
        Routes={{}}
      />
      {showAddButton && workspace && onAddPress && (
        <Pressable>
          <AddButton onPress={onAddPress} />
        </Pressable>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: tokens.spacing.md,
  },
});
